const runOptional = (request, onValue, source, onOptionalError, isCurrent) => (
  Promise.resolve()
    .then(request)
    .then(value => {
      if (isCurrent()) onValue(value);
      return value;
    })
    .catch(error => {
      if (isCurrent()) onOptionalError(source, error);
      return null;
    })
);

export function startBadgeDataLoad({
  backendService,
  startDate,
  endDate,
  onActivityStats,
  onCompliance,
  onBadgeStats,
  onOptionalError = () => {},
  isCurrent = () => true,
}) {
  // Start every independent badge request together. Compliance is the
  // authoritative source for the central totem and is therefore the only
  // request allowed to mark the badge renderable.
  const activityStats = runOptional(
    () => backendService.fetchActivityStats(startDate, endDate),
    onActivityStats,
    'activity stats',
    onOptionalError,
    isCurrent,
  );
  const badgeStats = runOptional(
    () => backendService.fetchBadgeStats(),
    onBadgeStats,
    'badge details',
    onOptionalError,
    isCurrent,
  );
  const complianceReady = Promise.resolve()
    .then(() => backendService.fetchCompliance([7, 30, 365]))
    .then(compliance => {
      const annualRate = compliance?.[365]?.rate;
      if (!Number.isFinite(annualRate) || annualRate < 0 || annualRate > 100) {
        throw new Error('Annual compliance is unavailable');
      }
      if (isCurrent()) onCompliance(compliance);
      return compliance;
    });

  return {
    complianceReady,
    settled: Promise.allSettled([activityStats, badgeStats, complianceReady]),
  };
}
